import { render, staticRenderFns } from "./taskFields.vue?vue&type=template&id=39f3c6f6&"
import script from "./taskFields.vue?vue&type=script&lang=js&"
export * from "./taskFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports